export const version = 'kunde-v1.16.0-SNAPSHOT-1225a01477fa78833cc5b7591c34f473f821d6fe';